import React, { useMemo } from 'react';
import { View } from "@/views/component/discount/style";
import Button from "@/views/component/public/button";
import { EButton, EModal } from "@/interface/enum";
import { useMobx } from "@/utils/hooks";
import { useMemoizedFn } from "ahooks";
import { Modal } from "@/views/component/modal";
import { ConfDoEntrysTasks } from "@/interface/request.interface";
import { observer } from "mobx-react-lite";

function Index() {
  const operate = useMobx('operate');

  const isJoinActive = useMemo(() => {
    let bool = false;

    if (!bool) {
      operate.dayFreeTask.forEach((gameTask: ConfDoEntrysTasks) => {
        if (gameTask.taskStatus === 100) {
          bool = true;
        }
      })
    }

    return bool
  }, [operate.dayFreeTask])

  const handleOriginalBuy = useMemoizedFn(() => {
    if (isJoinActive) {
      window.open(CONFIG.discount.linkSite.originalBuy, '_blank');
      return
    }
    $refPopup.current.open(<Modal modalType={EModal['提示']} message={CONFIG.discount.modalTip.originalBuy}/>);
  });
  const handleDiscountBuy = useMemoizedFn(() => {
    if (isJoinActive) {
      window.open(CONFIG.discount.linkSite.discountBuy, '_blank');
      return
    }
    $refPopup.current.open(<Modal
      modalType={EModal['提示']}
      message={CONFIG.discount.modalTip.discountBuy}
      confirmFn={(props: any) => {
        window.scrollTo(0, 300);
        props.clearAll()
      }}
    />);
  });

  const handleGetLog = useMemoizedFn(() => {
    const params = {
      type: 0,
      params: [
        `//hd.vip.yy.com/service/hdplatform/drawgift/${CONFIG.discount.YYVIPACTCODE}/mygiftppaging`,
        {
          dataType: 'jsonp',
          data: {
            hdIndex: CONFIG.discount.YYVIPACTCODE,
            drawGiftGroupId: CONFIG.discount.YYVIPDRAWGIFTGROUPID,
            pageIndex: 1,
            pageSize: 999
          }
        }
      ]
    };
    $refPopup.current.open(<Modal
      modalType={EModal['领取记录']}
      other={params}
    />);
  })
  const handlePresenterLog = useMemoizedFn(() => {
    const postData = {
      type: 1,
      params: [
        `//hd.vip.yy.com/service/hdplatform/drawgift/${CONFIG.discount.YYVIPACTCODE}/myreceiver`,
        {
          dataType: 'jsonp',
          data: {
            drawGiftGroupId: CONFIG.discount.YYVIPDRAWGIFTGROUPID
          }
        }
      ]
    };
    $refPopup.current.open(<Modal
      modalType={EModal['赠送记录']}
      other={postData}
    />);
  })

  return <View>
    <div className="tip1" dangerouslySetInnerHTML={({ __html: CONFIG.discount.tip1 })}></div>
    <div className="tip2" dangerouslySetInnerHTML={({ __html: CONFIG.discount.tip2 })}></div>
    {/*领取记录*/}
    <div onClick={() => handleGetLog()} className="log"/>
    {/*赠送记录*/}
    <div onClick={() => handlePresenterLog()} className="presenter"/>
    <ul>
      {CONFIG.discount.award.map((item: any, index: number) => {
        return <li key={index}>
          <img src={item.awardImg} alt=""/>
          <p>{item.name}</p>
        </li>
      })}
    </ul>
    <Button onClick={() => handleDiscountBuy()} type={EButton["折扣-折扣购买"]} className="discount"/>
    <Button onClick={() => handleOriginalBuy()} type={EButton["折扣-原价购买"]} className="origin"/>
  </View>
}

export default observer(Index);
